export var OrderStatusEnum;
(function (OrderStatusEnum) {
    // The order is initialized, and no callback from the payment supplier is received at this time.
    OrderStatusEnum["Initialized"] = "Initialized";
    // The supplier calls back a new order and the user has not paid successfully. When the front end jumps back to Portkey, this is the most likely state.
    OrderStatusEnum["Created"] = "Created";
    // Order payment successful
    OrderStatusEnum["Pending"] = "Pending";
    // Start settling ELF with merchants
    OrderStatusEnum["StartTransfer"] = "StartTransfer";
    // The transfer transaction has been sent, but the transaction has not been packaged yet
    OrderStatusEnum["Transferring"] = "Transferring";
    // The transaction has been packaged and is waiting for LIB (the transaction is in Mined status)
    OrderStatusEnum["Transferred"] = "Transferred";
    // Transfer transaction failed, ready to try again (When the Pending status is waiting for packaging, other statuses other than Mined are queried)
    OrderStatusEnum["TransferFailed"] = "TransferFailed";
    // User payment failed
    OrderStatusEnum["Failed"] = "Failed";
    // LIB confirmed
    OrderStatusEnum["Finish"] = "Finish";
})(OrderStatusEnum || (OrderStatusEnum = {}));
